export default "__VITE_ASSET__BHrop_Ak__"